/*
 * File: 变更日志
 */
<template>
    <div>
        <table-box
            v-loading="historyList.tableLoading"
            :height="config.height"
            :selection="config.selection"
            :index="config.index"
            :columns="config.columns"
            :actions="config.actions"
            :rows="historyList.totalData"
        />
        <div class="footer">
            <lots-pagination
                @size-change="historyList.sizeChange"
                :current-page.sync="historyList.pageNo"
                @current-change="historyList.pageChange"
                size="small"
                layout="total, sizes, prev, pager, next, jumper"
                :total="historyList.pageTotal"
            />
        </div>
    </div>
</template>

<script>
import { watch, reactive } from '@vue/composition-api';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getLocalCustomerManagerHistoryList } from '@mdm/api/customer/customerSeries.js';
import { tableConfig } from './config.js';

export default {
    components: {
        lotsPagination, tableBox
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => {}
        }
    },
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        class HistoryListClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.customerGroupCode = props.detailData.customerGroupCode;
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    historyList.totalData.value = res.data.list || [];
                    historyList.pageTotal.value = res.data.totalCount || 0;
                }
            }
        };
        const historyList = new HistoryListClass({
            Api: {
                listApi: getLocalCustomerManagerHistoryList
            }
        });
        watch(
            () => [props.activeName, props.detailData],
            (val) => {
                historyList.totalData.value = [];
                historyList.pageTotal.value = 0;
                if (val[0] === 'history' && val[1].customerGroupCode) {
                    historyList.getList();
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            historyList
        };
    }
};
</script>

<style lang="less" scoped>
.footer {
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
